import React from "react";

export const OrText = ({ text = "Or" }: { text?: string }) => {
  return (
    <div className="flex flex-row items-center gap-6">
      <hr className="border-grey-200 w-full border" />
      <span className="text-grey-600 text-sm">{text}</span>
      <hr className="border-grey-200 w-full border" />
    </div>
  );
};
